import CloseIcon from '@mui/icons-material/Close';
import { Button, Stack, Typography } from '@mui/material';
import useFilterActions from 'pages/PlaygroundV2Page/Filter/useFilterActions';
import { BRIGHT_BLUE, DARK_GREY, DARKER_WHITE } from 'utils/theme';

const FilterHelper = ({ numberOfmissingSources }: { numberOfmissingSources: number }) => {
  const { resetFilters } = useFilterActions();

  return (
    <Stack
      py={{ desktop: 2, tablet: 2, mobile: 2 }}
      px={{ desktop: 4, tablet: 4, mobile: 2 }}
      direction="row"
      alignItems="center"
      border="1px solid"
      borderColor={DARKER_WHITE}
      bgcolor="white"
      mb={2}
    >
      <Button
        endIcon={<CloseIcon />}
        variant="contained"
        onClick={() => resetFilters()}
        sx={{
          fontSize: {
            desktop: '0.875rem',
            tablet: '0.875rem',
            mobile: '0.7rem',
          },
          fontWeight: 400,
          bgcolor: BRIGHT_BLUE,
          borderRadius: '24px',
          boxShadow: 'none',
          textTransform: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        Clear all filters
      </Button>
      {numberOfmissingSources > 0 && (
        <Typography
          color={DARK_GREY}
          ml={2}
          fontSize={{
            desktop: '0.875rem',
            tablet: '0.875rem',
            mobile: '0.7rem',
          }}
        >
          {numberOfmissingSources} source{numberOfmissingSources > 1 && 's'}{' '}
          {numberOfmissingSources > 1 ? 'are' : 'is'} hidden
        </Typography>
      )}
    </Stack>
  );
};

export default FilterHelper;
